import AffiliateA from './Affiliate/AffiliateA';
import Alert from './Alert';
import ArrowButton from './ArrowButton';
import Button from './Button';
import CardBlogA from './CardBlog/CardBlogA';
import CardBlogB from './CardBlog/CardBlogB';
import CardBlogC from './CardBlog/CardBlogC';
import CardIconA from './CardIcon/CardIconA';
import CardIconD from './CardIcon/CardIconD';
import CardIconE from './CardIcon/CardIconE';
import CardIconF from './CardIcon/CardIconF';
import CardImageA from './CardImage/CardImageA';
import CardImageB from './CardImage/CardImageB';
import CardImageD from './CardImage/CardImageD';
import CardImageE from './CardImage/CardImageE';
import CardImageF from './CardImage/CardImageF';
import CardImageG from './CardImage/CardImageG';
import CardImageH from './CardImage/CardImageH';
import CardImageI from './CardImage/CardImageI';
import CardImageFooterA from './CardImageFooter/CardImageFooterA';
import CardListA from './CardList/CardListA';
import CardListB from './CardList/CardListB';
import CardListC from './CardList/CardListC';
import CardListD from './CardList/CardListD';
import CardListMessageA from './CardListMessage/CardListMessageA';
import CardTextA from './CardText/CardTextA';
import CardTextB from './CardText/CardTextB';
import CardTextC from './CardText/CardTextC';
import CardTextD from './CardText/CardTextD';
import CardProductAItem from './CardProduct/CardProductAItem';
import CardProductB from './CardProduct/CardProductB';
import CardProductC from './CardProduct/CardProductC';
import CardProductDItem from './CardProduct/CardProductDItem';
import CardProductE from './CardProduct/CardProductE';
import CardProductF from './CardProduct/CardProductF';
import CardProductG from './CardProduct/CardProductG';
import CardProductGList from './CardProduct/CardProductGList';
import CardProductH from './CardProduct/CardProductH';
import CardProductJ from './CardProduct/CardProductJ';
import CardProductK from './CardProduct/CardProductK';
import CardProductRadio from './CardProduct/CardProductRadio';
import CffpCartButton from './CartButton/CffpCartButton';
import './ContentBlock/ContentBlock.scss';
import DefaultCartButton from './CartButton/DefaultCartButton';
import DesigneeSearchA from './DesigneeSearch/DesigneeSearchA';
import ExpandableList from './ExpandableList';
import ExpandableListItemA from './ExpandableListItem/ExpandableListItemA';
import ExpandableListItemB from './ExpandableListItem/ExpandableListItemB';
import ExpandableListItemC from './ExpandableListItem/ExpandableListItemC';
import ExpandableListItemD from './ExpandableListItem/ExpandableListItemD';
import External from './External';
import FontIcon from './FontIcon';
import Footer from './Footer';
import GenesysChat from './GenesysChat';
import HeroA from './Hero/HeroA';
import HeroB from './Hero/HeroB';
import HeroC from './Hero/HeroC';
import HeroList from './Hero/HeroList';
import ImageA from './Image/ImageA';
import ImportProduct from './ImportProduct';
import InstructorA from './Instructor/InstructorA';
import InstructorB from './Instructor/InstructorB';
import InstructorList from './Instructor/InstructorList';
import Link from './Link';
import ModalB from './Modal/ModalB';
import NavA from './Nav/NavA';
import NavB from './Nav/NavB';
import NavC from './Nav/NavC';
import NavD from './Nav/NavD';
import NavDropdown from './Nav/NavDropdown';
import NavE from './Nav/NavE';
import NavF from './Nav/NavF';
import NavG from './Nav/NavG';
import PackageTabA from './PackageTab/PackageTabA';
import PackageTabB from './PackageTab/PackageTabB';
import PackageTabC from './PackageTab/PackageTabC';
import PaginationA from './Pagination/PaginationA';
import ProductFilterA from './ProductFilter/ProductFilterA';
import ProductSearchA from './ProductSearch/ProductSearchA';
import ResultTableA from './ResultTable/ResultTableA';
import ReusableContentA from './ReusableContent/ReusableContentA';
import ReusableContentList from './ReusableContent/ReusableContentList';
import ScheduledContentA from './ScheduledContent/ScheduledContentA';
import SearchBarA from './SearchBar/SearchBarA';
import SearchBarB from './SearchBar/SearchBarB';
import SearchButtonA from './SearchButton/SearchButtonA';
import SearchButtonB from './SearchButton/SearchButtonB';
import SelectA from './Select/SelectA';
import SelectB from './Select/SelectB';
import SelectC from './Select/SelectC';
import SelectD from './Select/SelectD';
import SeminarDateTime from './SeminarDetails/SeminarDateTime';
import SeminarDetailsModal from './SeminarDetails/SeminarDetailsModal';
import SeminarLocation from './SeminarDetails/SeminarLocation';
import SeminarSchedulerA from './SeminarScheduler/SeminarSchedulerA';
import SiteNavA from './SiteNav/SiteNavA';
import SiteNavB from './SiteNav/SiteNavB';
import VideoPlayer from './VideoPlayer';
import VideoPlayerListA from './VideoPlayerList/VideoPlayerListA';
import VideoPlayerListB from './VideoPlayerList/VideoPlayerListB';

const externalComponents = {
  HeroD: External,
  HeroE: External,
  HeroF: External,
  HeroG: External,
};

export default {
  // All the components you'd like to render server-side
  AffiliateA,
  Alert,
  ArrowButton,
  Button,
  CardBlogA,
  CardBlogB,
  CardBlogC,
  CardIconA,
  CardIconD,
  CardIconE,
  CardIconF,
  CardImageA,
  CardImageB,
  CardImageD,
  CardImageE,
  CardImageF,
  CardImageG,
  CardImageH,
  CardImageI,
  CardImageFooterA,
  CardListA,
  CardListB,
  CardListC,
  CardListD,
  CardListMessageA,
  CardTextA,
  CardTextB,
  CardTextC,
  CardTextD,
  CardProductAItem,
  CardProductB,
  CardProductC,
  CardProductDItem,
  CardProductE,
  CardProductF,
  CardProductG,
  CardProductGList,
  CardProductH,
  CardProductJ,
  CardProductK,
  CardProductRadio,
  CffpCartButton,
  DefaultCartButton,
  DesigneeSearchA,
  ExpandableList,
  ExpandableListItemA,
  ExpandableListItemB,
  ExpandableListItemC,
  ExpandableListItemD,
  External,
  FontIcon,
  Footer,
  GenesysChat,
  HeroA,
  HeroB,
  HeroC,
  HeroList,
  ImageA,
  ImportProduct,
  InstructorA,
  InstructorB,
  InstructorList,
  Link,
  ModalB,
  NavA,
  NavB,
  NavC,
  NavD,
  NavDropdown,
  NavE,
  NavF,
  NavG,
  PackageTabA,
  PackageTabB,
  PackageTabC,
  PaginationA,
  ProductFilterA,
  ProductSearchA,
  ResultTableA,
  ReusableContentA,
  ReusableContentList,
  ScheduledContentA,
  SearchBarA,
  SearchBarB,
  SearchButtonA,
  SearchButtonB,
  SelectA,
  SelectB,
  SelectC,
  SelectD,
  SeminarDateTime,
  SeminarDetailsModal,
  SeminarLocation,
  SeminarSchedulerA,
  SiteNavA,
  SiteNavB,
  VideoPlayer,
  VideoPlayerListA,
  VideoPlayerListB,
  ...externalComponents,
};
